import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Paper from '@material-ui/core/Paper'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import { withStyles } from '@material-ui/core/styles'


const styles = () => ({
  root: {
    marginTop: 30,
    marginBottom: 10,
  },
  appbar: {
    borderRadius: '0 0 3px 3px',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

const Panel = ({
  color,
  classes,
  children,
  className,
  contentClassName,
}) => (
  <Paper className={classNames(classes.root, className)}>
    <AppBar
      color={color}
      elevation={0}
      position="static"
      className={classes.appbar}
    >
      <Toolbar className={classNames(classes.toolbar, contentClassName)}>
        {children}
      </Toolbar>
    </AppBar>
  </Paper>
)


Panel.defaultProps = {
  color: 'default',
}


Panel.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
}


export default withStyles(styles)(Panel)
